import { Box, Button, Typography } from "@mui/material";

import { KillSkillTypeList } from "../../constants/killskill";
import useStyles from "./index.styles";
import { KillSkillType } from "../../types/KillSkillType";
import { toUSDFormat } from "../../utils/utils";

const KillSkillListItem = ({
  killSkill,
  onAttempt,
  disabled,
}: {
  killSkill: KillSkillType;
  onAttempt: (killSkillType: number) => void;
  disabled: boolean;
}) => {
  const { classes } = useStyles();

  const handleAttempt = () => {
    if (!disabled) {
      onAttempt(killSkill.id);
    }
  };

  return (
    <Box className={classes.killSkillListItem}>
      <Typography className={classes.killSkillTitle}>
        {killSkill.title}
      </Typography>
      <Box
        component="img"
        src={killSkill.image}
        alt={killSkill.title}
        className={classes.killSkillImage}
      />

      <Box className={classes.killSkillListItemFooter}>
        <Box className={classes.killSkillListItemFooterText}>
          <Typography className={classes.successChanceText}>
            {killSkill.percentage}%
          </Typography>
          <Typography className={classes.successChanceLabelText}>
            Success chance
          </Typography>
        </Box>

        <Box className={classes.killSkillListItemFooterText}>
          <Box display={"flex"} alignItems={"center"} gap={1}>
            <Box
              component={"img"}
              src="/assets/imgs/layout/currency.png"
              sx={{
                width: 16,
                height: 16,
              }}
            ></Box>
            <Typography className={classes.successChanceText}>
              {toUSDFormat(killSkill.cost)}
            </Typography>
          </Box>
          <Typography className={classes.successChanceLabelText}>
            Training cost
          </Typography>
        </Box>

        <Button
          variant="contained"
          className={classes.attemptButton}
          onClick={handleAttempt}
          disabled={disabled}
        >
          Attempt now
        </Button>
      </Box>
    </Box>
  );
};

const KillSkillList = ({
  handleAttempt,
  disabled,
}: {
  handleAttempt: (killSkillType: number) => void;
  disabled: boolean;
}) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.killSkillList}>
      {KillSkillTypeList.map((killSkill, index) => (
        <KillSkillListItem
          killSkill={killSkill}
          key={index}
          onAttempt={handleAttempt}
          disabled={disabled}
        />
      ))}
    </Box>
  );
};

export default KillSkillList;
